import styled from 'styled-components';

const Shaded = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${({theme}) => theme.color.name === 'dark' ? 'rgba(0, 0, 0, .5)' : 'rgba(0, 0, 0, .3)'};
`;

const Overlay = styled(({className, children, onClose}) => (
    <div className={className}>
        <Shaded
            role="button"
            onClick={(event) => {
                event.stopPropagation();
                onClose();
            }}
        />
        {children}
    </div>
))`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export default Overlay;
